import TemplateNames from '../email-messages/TemplateNames';
import MarketingSubscriptionSources from '../followers/MarketingSubscriptionSources';

export default {
  title: 'Panoramica marketing',
  tiles: {
    followers: 'Follower',
    delivered_messages: 'Messaggi recapitati',
    open_rate: 'Tasso di apertura',
    click_rate: 'Tasso di clic',
    spam_report_rate: 'Tasso di segnalazioni spam',
    unsubscribe_rate: 'Tasso di disiscrizione',
  },
  subscriprion_sources_table: {
    source_names: MarketingSubscriptionSources,
    columns: {
      subscription_source: 'Fonte di iscrizione',
      count: 'Conteggio',
      percentage: 'Percentuale',
    },
  },
  templates_table: {
    template_names: TemplateNames,
    columns: {
      template: 'Modello',
      delivered: 'Recapitato',
      open_rate: 'Tasso di apertura',
      click_rate: 'Tasso di clic',
      spam_report_rate: 'Tasso di segnalazioni spam',
      unsubscribe_rate: 'Tasso di disiscrizione',
    },
  },
  labels: {
    no_data: 'Nessun dato',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
  },
};
